import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Fotbal american",
    Baseball: "Baseball",
    Basketball: "Baschet",
    Boxing: "Box",
    Chess: "Șah",
    Cricket: "Cricket",
    Darts: "Darts",
    Entertainment: "Divertisment",
    "E-Sports": "E-Sports",
    Football: "Fotbal",
    "Formula 1": "Formula 1",
    "Gaelic Football": "Sporturi Galice",
    "Generic Sport": "Sport Generic",
    Golf: "Golf",
    "Greyhound Racing": "Curse de ogari",
    Handball: "Handbal",
    "Ice Hockey": "Hochei pe gheaţă",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politică",
    "Rugby League": "Rugby League",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Tenis de Masă",
    Tennis: "Tenis",
    "Virtual Football": "Fotbal virtual",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} să câștige",
    WinFirstRound: "{name} să câștige prima rundă",
    FirstTouchdown: "{name} să înscrie un touchdown prima",
    FirstTry: "{name} să înscrie o încercare prima",
    TotalGoals: "{name} total goluri",
    TotalRuns: "{name} total runuri",
    TotalPoints: "{name} total puncte",
    TopBatsman: "{name} să fie Top Batsman",
    TopBowler: "{name} să fie Top Bowler",
    FirstScore: "{name} să înscrie prima"
  },
  PromoTexts: {
    Pick: "Adaugă selecțiile",
    Bet: "Pariază",
    Pays: "Câștigă"
  },
  DateTimeTexts: {
    Today: "Azi",
    Tomorrow: "Mâine",
    Live: "Live"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Adaugă selecțiile",
    Return: "Câștigă",
    Stake: "Pariază",
    Draw: "X"
  },
  H2HTexts: {
    goals_scored: "Goluri înscrise",
    shots: "Șuturi",
    shots_on_target: "Șuturi pe poartă",
    ball_possession: "Posesia mingii",
    goals_conceded: "Goluri Primite",
    "Per match": "per meci",
    H2H: "H2H",
    W: "V",
    D: "E",
    L: "Î",
    T: "E",
    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
